import { useState, useEffect } from 'react';
import { Textarea, PillButtons, Label, Help } from '../../input';
import { Error } from '../../error';
import { TableFromObject } from '../../table';

export const TemplateInput = ({ params, onChange, errors }) => {
  const [didInit, setDidInit] = useState();
  const [tab, setTab] = useState('prompt');
  const [template, setTemplate] = useState('');
  const [templateSchema, setTemplateSchema] = useState('');

  const updateFromPrompt = () => {
    onChange('template', template);
  };

  const updateFromSchema = () => {
    const t = {};
    for (const line of (templateSchema || '').split('\n')) {
      const m = line.trim().match(/([^ ]+) ?(.*)?/);
      if (!m) {
        continue;
      }
      const [name, description] = [m[1].trim(), (m[2] || '').trim()];
      t[name] = description;
    }
    onChange('template', t);
  };

  // useEffect(() => {
  //   return;

  //   if (params.template) {
  //     console.log('params changed', params);
  //     if (typeof params.template == 'string') {
  //       const same = params.template == template;
  //       if (!same) {
  //         setTemplate(params.template);
  //         if (tab != 'prompt') {
  //           setTab('prompt');
  //         }
  //       }
  //     } else {
  //       const ser = Object.entries(params.template || {})
  //         .map(([k, v]) => `${k} ${v}`)
  //         .join('\n');

  //       const same = ser == JSON.stringify(templateSchema);
  //       if (!same) {
  //         setTemplateSchema(ser);
  //         if (tab != 'schema') {
  //           setTab('schema');
  //         }
  //       }
  //     }
  //   }
  // }, [params]);

  useEffect(() => {
    console.log('params.template changed:', didInit, params.template);

    if (didInit) {
      return;
    }
    setDidInit(true);

    if (typeof params.template == 'string') {
      setTemplate(params.template);
    } else {
      setTemplateSchema(
        Object.entries(params.template || {})
          .map(([k, v]) => `${k} ${v}`)
          .join('\n'),
      );
    }
  }, [params?.template]);

  useEffect(() => {
    if (tab == 'prompt') {
      updateFromPrompt();
    } else {
      updateFromSchema();
    }
  }, [tab]);

  useEffect(() => {
    if (tab != 'prompt') {
      return;
    }
    updateFromPrompt();
  }, [template]);

  useEffect(() => {
    if (tab != 'schema') {
      return;
    }
    updateFromSchema();
  }, [templateSchema]);

  const promptNode = (
    <div>
      <Help help="Describe the data you'd like to extract. The AI will figure out the schema." />
      <Textarea
        minRows={3}
        style={{ width: '100%', height: 120 }}
        value={template}
        onChange={(e) => setTemplate(e.target.value)}
        placeholder={`name Name of the item on this page\nnumber Number of the item on this page`}
      />
      <Error small message={errors?.template} />
    </div>
  );

  const schemaNode = (
    <div>
      <Help help="Enter the data schema as one field per line. First word in the line is the field name, rest of the line is descrption." />
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 20 }}>
        <div style={{ width: '50%' }}>
          <Textarea
            minRows={3}
            style={{ width: '95%', height: 120 }}
            value={templateSchema}
            onChange={(e) => setTemplateSchema(e.target.value)}
            placeholder={`field_one Description of the first field\nfield_two Second field description`}
          />
        </div>
        <div style={{ width: '50%' }}>
          <TableFromObject obj={params.template} />
        </div>
      </div>
      <Error small message={errors?.template} />
    </div>
  );

  return (
    <div>
      <Label label="Template" />
      <PillButtons
        size="sm"
        value={tab}
        onChange={setTab}
        choices={[
          ['prompt', 'Prompt'],
          ['schema', 'Schema'],
        ]}
      />
      {tab == 'prompt' && promptNode}
      {tab == 'schema' && schemaNode}
    </div>
  );
};
